{ avatarDomain } = require '@trello/config'
t = require('app/scripts/views/internal/teacup-with-helpers')('entity')
commentEditControls = require('app/scripts/views/templates/comment_edit_controls')
commentOptions = require('app/scripts/views/templates/comment_options')

module.exports = t.renderable (entity, context, options) ->
  { type, text } = entity

  switch type
    when 'text', 'list', 'checklist', 'plugin', 'date'
      t.text text

    when 'card'
      { url } = entity
      t.a '.action-card', { href: url }, ->
        t.text text

    when 'board'
      { url } = entity
      t.a { href: url }, ->
        t.text text

    when 'organization'
      { url } = entity
      t.a { href: url }, text || t.l('an-organization')

    when 'checkItem'
      { nameHtml } = entity
      if nameHtml
        t.raw nameHtml
      else
        t.text text

    when 'comment'
      { textHtml } = entity
      { canEdit } = context
      { truncateComment, extremeTruncation } = options
      t.div '.comment-container', ->
        classes =
          'action-comment': true
          'can-edit': canEdit
          'markeddown': true
          'js-comment': true
          'is-truncated': truncateComment
          'extreme-truncation': extremeTruncation
        t.div { class: t.classify(classes), dir: 'auto' }, ->
          if truncateComment
            t.div '.action-comment-fade-button.js-expand-comment'
          t.div '.current-comment.js-friendly-links.js-open-card', ->
            t.raw textHtml
          if canEdit
            t.div '.comment-box.mod-editing-comment', ->
              t.textarea '.comment-box-input.js-text', { tabindex: '1' }, ->
                t.text text
              commentEditControls()
              commentOptions(true)

    when 'customField'
      t.text text

    when 'customFieldItem'
      t.text text

    when 'label'
      { color } = entity
      classes =
        'card-label': true
      classes[color + '-label'] = true
      title = text || "#{ color } label (default)"

      t.span { class: t.classify(classes), title }, ->
        if text
          t.text text
        else
          t.raw '&nbsp;'

    when 'attachment'
      { link, url, isTrelloAttachment, isTrello, id, isFriendly } = entity
      if link || isFriendly
        if isTrelloAttachment
          t.a '.js-open-attachment-viewer', { href: url, 'data-idattachment': id }, ->
            t.text text
        else if isTrello
          t.a '.js-friendly-links', { href: url }, ->
            t.text text
        else
          t.a '.js-friendly-links', { href: url, target: '_blank', rel: 'noopener noreferrer' }, ->
            t.text text
      else
        t.span '.attachment-deleted', ->
          t.text text

    when 'attachmentPreview'
      { previewUrlForRes, originalUrl, id } = entity
      { showCompactAttachmentPreview } = options

      if previewUrlForRes
        classes =
          'js-open-attachment-viewer': !showCompactAttachmentPreview
          'js-open-card': showCompactAttachmentPreview
          'js-friendly-links': true

        previewClasses =
          'attachment-image-preview': true
          'mod-compact-image-preview': showCompactAttachmentPreview

        t.a { class: t.classify(classes), href: originalUrl, target: '_blank', 'data-idattachment': id }, ->
          t.img { class: t.classify(previewClasses), src: previewUrlForRes }
      else
        t.raw '&nbsp;'

    when 'member'
      { id, avatarHash, username } = entity
      t.span '.inline-member.js-show-mem-menu', { idMember: id }, ->
        if avatarHash
          title = "#{ text } (#{ username })"
          t.img '.inline-member-av', { src: [avatarDomain, avatarHash, '30.png'].join('/'), alt: title, title }
        t.span '.u-font-weight-bold', ->
          t.text text

    when 'relDate'
      { date, current } = entity
      t.span '.rel-date', { dt: date, text: text }, ->
        t.text current

    when 'plugin'
      t.text t.mustacheVar('text')
